import i18n from "i18next";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import {CommonVI} from "./common/vi";
import {CommonEN} from "./common/en";
import {LayoutEN} from "./common/layout/en";
import {LayoutVI} from "./common/layout/vi";
import {SettingEN} from "./setting/en";
import {SettingVI} from "./setting/vi";
import {HrmEN} from "./hrm/en";
import {HrmVI} from "./hrm/vi";
import {SystemEN} from "./system/en";
import {SystemVI} from "./system/vi";
import {MedialFileEN} from "./common/file-upload/en";
import {MediaFileVI} from "./common/file-upload/vi";
import {DashboardEn} from "./dashboard/en";
import {DashboardVi} from "./dashboard/vi";
import {getLanguage} from "../custom/axios";

const resources = {
    en: {
        translation: {
            ...CommonEN,
            ...LayoutEN,
            ...SettingEN,
            ...HrmEN,
            ...SystemEN,
            ...MedialFileEN,
            ...DashboardEn
        }
    },
    vi: {
        translation: {
            ...CommonVI,
            ...LayoutVI,
            ...SettingVI,
            ...HrmVI,
            ...SystemVI,
            ...MediaFileVI,
            ...DashboardVi
            // ...GeneralSettingsVI
        }
    },
    de: {
        translation: {
            ...CommonEN,
            ...LayoutEN,
            ...SettingEN,
            ...HrmEN,
            ...SystemEN,
            ...MedialFileEN,
            ...DashboardEn
        }
    }

}

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: getLanguage(),
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
